import AcidWashCard from "./AcidWashCard";
import AcidWashCardTurkey from "./AcidWashCardTurkey";
import GarmentProdCheckListCard from "./garmentProdChecklist/GarmentProdCheckListCard";
import IncotermsCard from "./incoterms/IncotermsCard";

/**
 * Lista ordenada de cards de Conocimiento.
 * Para añadir una nueva: crea tu componente y añade una entrada { id, Component } aquí.
 */
export const KNOWLEDGE_CARDS = [
  { id: "acid-wash", Component: AcidWashCard },
  { id: "acid-wash-turkey", Component: AcidWashCardTurkey },
  {
    id: "garment-prod-checklist-es",
    Component: GarmentProdCheckListCard,
  },
  { id: "incoterms-2010", Component: IncotermsCard },
];
